// features/clients/clientSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { clientService } from "./clientService";

export const getAllClients = createAsyncThunk("clients/get", async (_, thunkAPI) => {
  try {
    return await clientService.getClients();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getAClient = createAsyncThunk("client/get", async (id, thunkAPI) => {
  try {
    return await clientService.getClient(id);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

const clientState = {
  clients: [],
  singleClient: null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
};

const clientSlice = createSlice({
  name: "clientFrontend",
  initialState: clientState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllClients.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllClients.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.clients = action.payload;
      })
      .addCase(getAllClients.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.error;
      })
      .addCase(getAClient.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAClient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.singleClient = action.payload;
      })
      .addCase(getAClient.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.error;
      });
  },
});

export default clientSlice.reducer;
